<!--@Deprecated use /decisioning-criteria/components/CriterionInputComponents/...-->
<template>
    <div class="CriterionCurrencyInput">
        <FormElement :label="hideTitle ? undefined : schema.title">
            <template v-if="schema.description" #labelHint>
                <div
                    v-tooltip="schema.description"
                    class="CriterionEnumInput__hintIcon"
                >
                    <FontAwesomeIcon :icon="faQuestionCircle" />
                </div>
            </template>
            <FormInput :invalid="showValidationErrors && (showError || accessed) && hasError" force-error-slot>
                <currency-input
                    class="CurrencyInput"
                    :value="value"
                    :precision="0"
                    :disabled="rbacDisabled"
                    value-as-integer
                    currency="usd"
                    locale="en-US"
                    @input="onInput"
                    @blur="touch"
                    @focus="onFocus"
                />
                <template v-if="showValidationErrors && (showError || accessed) && hasError" #errorMessage>
                    {{ errorMessage }}
                </template>
                <template v-if="deletable || rbacDisabled" #actionButtons>
                    <LockInputIcon v-if="rbacDisabled" />
                    <NewButton
                        v-else-if="deletable"
                        variant="flat"
                        size="icon-sm"
                        color="secondary"
                        class="JsonSchemaForm__deleteIcon"
                        @click="$emit('delete')"
                    >
                        <EidIcon :icon-src="faXmark" alt="delete" />
                    </NewButton>
                </template>
            </FormInput>
        </FormElement>
    </div>
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
    import { faXmark } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    // PRODUCT-26110 Task 8b Step 5b: vue-currency-input's own component/directive is
    // Vue-2-only and dropped outright in v3; this shared dashboard-commons wrapper
    // (built on the v3 `useCurrencyInput` composable) is a drop-in replacement with the
    // same value/currency/locale/precision/valueAsInteger/disabled props and
    // input/blur/focus events -- see its own file for the composable migration detail.
    import CurrencyInput from '@evidentid/dashboard-commons/components/CurrencyInput/CurrencyInput.vue';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { FormElement, FormInput } from '@evidentid/dashboard-commons/components/Form';
    import LockInputIcon from '@evidentid/dashboard-commons/components/LockInputIcon/LockInputIcon.vue';
    import { JsonSchemaInteger, JsonSchemaNumber } from '@evidentid/json-schema/interfaces/JsonSchema';

    import NewButton from '@/components/new-button/NewButton.vue';

    import AbstractCriterionInput
        from './AbstractCriterionInput';

    type JsonSchemaNumeric = JsonSchemaNumber | JsonSchemaInteger;

    @Component({
        emits: [ 'delete', 'input' ],
        components: { EidIcon, FormInput, CurrencyInput, FontAwesomeIcon, FormElement, LockInputIcon, NewButton },
    })
    export default class CriterionCurrencyInput extends AbstractCriterionInput<JsonSchemaNumeric, number> {
        // @Deprecated use /decisioning-criteria/components/CriterionInputComponents/...
        private faXmark = faXmark;
        private faQuestionCircle = faQuestionCircle;

        private onInput(amount: number): void {
            this.$emit('input', amount);
        }
    }
</script>
